import React from "react";
import styles from "./Navbar.module.scss";
import { Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
// Images and logos
import DashboardIcon from "@material-ui/icons/Dashboard";
import LocalMallIcon from "@material-ui/icons/LocalMall";
import CategoryIcon from "@material-ui/icons/Category";
import AccountBalanceWalletIcon from "@material-ui/icons/AccountBalanceWallet";
import ListAlt from "@material-ui/icons/ListAlt";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import InsertChartOutlined from "@material-ui/icons/InsertChartOutlined";
import { ReactComponent as Inventory } from "assets/images/icons/Hardware.svg";
// Components
import Button from "@material-ui/core/Button";

import { logout, userTypeSelector } from "slices/users/userSlice";
import { teamSelector } from "slices/event/teamSlice";
import { RootState } from "slices/store";
import { cartTotalSelector } from "slices/hardware/cartSlice";
import { getCreditsUsedSelector } from "slices/order/orderSlice";

interface NavBarProps {
    logout: any;
    pathname: string;
}

export const UnconnectedNavbar = ({ logout, pathname }: NavBarProps) => {
    const cartQuantity = useSelector(cartTotalSelector);
    const userType = useSelector(userTypeSelector);
    const creditsAvailable = useSelector(teamSelector)?.credits;
    const creditsUsed = useSelector(getCreditsUsedSelector);
    const creditsRemaining = creditsAvailable ? creditsAvailable - creditsUsed : 0;

    const isParticipant = userType === "participant";
    const isAdmin = userType === "admin";
    const isParticipantOrAdmin = isParticipant || isAdmin;

    return (
        <nav className={styles.nav}>
            <div className={styles.navFlexDiv}>
                {isParticipant && (
                    <Button
                        className={styles.navBtn}
                        aria-label="Credits"
                        startIcon={<AccountBalanceWalletIcon />}
                    >
                        Credits {Math.max(creditsRemaining, 0)}
                    </Button>
                )}
                {isParticipantOrAdmin && (
                    <Link to={"/"}>
                        <Button
                            className={
                                pathname === "/" ? styles.navActive : styles.navBtn
                            }
                            aria-label="Dashboard"
                            startIcon={<DashboardIcon />}
                        >
                            Dashboard
                        </Button>
                    </Link>
                )}
                {isAdmin && (
                    <Link to={"/orders"}>
                        <Button
                            className={
                                pathname === "/orders"
                                    ? styles.navActive
                                    : styles.navBtn
                            }
                            aria-label="Orders"
                            startIcon={<ListAlt />}
                        >
                            Orders
                        </Button>
                    </Link>
                )}
                {isAdmin && (
                    <Link to={"/teams"}>
                        <Button
                            className={
                                pathname === "/teams" ? styles.navActive : styles.navBtn
                            }
                            aria-label="Teams"
                            startIcon={<AccountBoxIcon />}
                        >
                            Teams
                        </Button>
                    </Link>
                )}
                {isAdmin && (
                    <Link to={"/reports"}>
                        <Button
                            className={
                                pathname === "/reports"
                                    ? styles.navActive
                                    : styles.navBtn
                            }
                            aria-label="Reports"
                            startIcon={<InsertChartOutlined />}
                        >
                            Reports
                        </Button>
                    </Link>
                )}
                {isParticipantOrAdmin && (
                    <Link to={"/inventory"}>
                        <Button
                            className={
                                pathname === "/inventory"
                                    ? styles.navActive
                                    : styles.navBtn
                            }
                            aria-label="Inventory"
                            startIcon={<Inventory fill="currentColor" width="20px" />}
                        >
                            Inventory
                        </Button>
                    </Link>
                )}
                {isParticipantOrAdmin && (
                    <Link to={"/threedprinting"}>
                        <Button
                            className={
                                pathname === "/threedprinting"
                                    ? styles.navActive
                                    : styles.navBtn
                            }
                            aria-label="threedprinting"
                            startIcon={
                                <CategoryIcon fill="currentColor" width="20px" />
                            }
                        >
                            3D Printing Services
                        </Button>
                    </Link>
                )}
                {isParticipant && (
                    <Link to={"/cart"}>
                        <Button
                            className={
                                pathname === "/cart" ? styles.navActive : styles.navBtn
                            }
                            aria-label="Cart"
                            startIcon={<LocalMallIcon />}
                        >
                            Cart ({cartQuantity})
                        </Button>
                    </Link>
                )}
            </div>
            <Button
                aria-label="Logout"
                className={`${styles.navBtn} ${styles.navBtnLogout}`}
                onClick={() => {
                    logout();
                }}
            >
                <b>Logout</b>
            </Button>
        </nav>
    );
};

const mapStateToProps = (state: RootState) => ({
    pathname: state.router.location.pathname,
});

const Navbar = connect(mapStateToProps, { logout })(UnconnectedNavbar);

export default Navbar;
